import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import md5 from 'md5';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/alert.actions';

import { BlueRightArrowIcon, BlueTickIcon, TrashIcon } from '../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_styles.css';

class Alert extends React.Component {
    state = {
        show: false,
    };

    isNew(_new) {
        if (_new === null) {
            return 'flex_auto_column alert_circule bg_lipstick';
        } else {
            return 'flex_auto_column alert_empty';
        }
    }

    isHide(show) {
        if (show) {
            return (
                'c_white alert_button center hand' +
                (this.props.pending ? ' bg_cornflower_blue' : ' bg_lipstick')
            );
        } else {
            return 'display_none';
        }
    }

    isShow(show) {
        return 'flex_full_row ' + (show ? 'margin_left_72 bg_ice_blue_two' : '');
    }

    handleClick = (e) => {
        this.setState({ show: !this.state.show });
    };

    handleAction = (e) => {
        if (this.props.pending) {
            this.props.dismiss(this.props.data.id);
            //.then((r) => this.props.loadAlert(sessionStorage.user));
        } else {
            this.props.deleteAlert(this.props.data.id);
            //.then((r) => this.props.loadAlert(sessionStorage.user));
        }
    };

    static getDerivedStateFromProps(props, state) {
        if (
            props.data !== state.data ||
            props.last !== state.last ||
            props.pending !== state.pending ||
            props.local !== state.local
        ) {
            state.data = props.data;
            state.last = props.last;
            state.pending = props.pending;
            state.local = props.local;
            return state;
        }
        return null;
    }

    render() {
        const { data, last, pending, local, show } = this.state;
        const familia = data.familia ? md5(data.familia) : '';
        if (!local) return null;
        return (
            <div
                id="alert"
                className={classNames(
                    'flex_full_row margin_left_12 margin_top_9',
                    last ? 'noshadow' : 'shadow',
                )}
            >
                <div className={this.isShow(show)} onClick={this.handleClick}>
                    <div className={this.isNew(data.isNew)} />
                    <div className="flex_full_column align_top">
                        <span className="flex_full margin_right_12 margin_bottom_12 c_dark_grey_blue barlow_medium_subtitle">
                            {data.texto && data.texto.trim()}
                        </span>
                        {data.idInstancia && (
                            <span className="c_slate_grey barlow_regular_smalltext margin_bottom_12 flex_full alert_description">
                                <FormattedMessage id="instance" />
                                {': '}
                                <Link
                                    to={`/processes/${familia}/${data.proceso}/${data.idInstancia}`}
                                >
                                    {data.idInstancia}
                                </Link>
                            </span>
                        )}
                    </div>
                    <div className="flex_auto_column align_top">
                        <span
                            className={
                                'c_cool_grey_two barlow_regular_little margin_right_18  nowrap'
                            }
                        >
                            {data.fechaAlta &&
                                data.fechaAlta.date &&
                                data.fechaAlta.date.substr(0, 16)}
                        </span>
                        <span
                            className={
                                'c_cornflower_blue barlow_regular_little margin_right_18  nowrap'
                            }
                        >
                            {local && local.name}
                        </span>
                    </div>
                    <div className="flex_auto_column center">
                        <BlueRightArrowIcon color="primary" onClick={this.handleClick} />
                    </div>
                </div>
                <div className={this.isHide(show)} onClick={this.handleAction}>
                    {pending ? <BlueTickIcon /> : <TrashIcon />}
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

Alert.propTypes = {
    history: PropTypes.object.isRequired,
};

export default connect(
    null,
    mapDispatchToProps,
)(withRouter(Alert));



// WEBPACK FOOTER //
// ./src/components/complex/alerts/Alert.js